export default "__VITE_ASSET__BC76pdMP__"